import { AdvancedShipNoticeStoreModule } from '@/shared';

export default AdvancedShipNoticeStoreModule;